<template>
  <section class="device-wraper">
    <p class="w-description">
      이 계정에 로그인 되어있는 디바이스 확인이 가능합니다.<br />
      사용하지 않는 디바이스를 로그아웃 시킬 수 있습니다.<br />
      리스트는 현재 기준 ~ 3개월 이전으로 노출되며 전체 개수는 별도 노출됩니다.
    </p>
    <em class="total-count-box">
      현재 로그인된 전체 기기 개수 :
      {{ loginDeviceTotalCount }} 개
    </em>
    <infinite-scroll-list
      v-if="deviceHistoryList?.length"
      @load-more-fn="loadMore"
    >
      <device-list
        :device-list="deviceHistoryList"
        @click-logout="onClickLogout"
      />
    </infinite-scroll-list>
    <div class="button-wrapper">
      <button type="button" class="all-logout-button" @click="onClickLogoutAll">
        다른 디바이스 모두 로그아웃
      </button>
    </div>
    <loading-progress :show-loading="isLoading" />
  </section>
</template>

<script setup>
  import DeviceList from '@/components/device/DeviceList.vue'
  import InfiniteScrollList from '@/components/scroll/InfiniteScrollList.vue'
  import LoadingProgress from '@/components/LoadingProgress.vue'
  import { onMounted, ref } from 'vue'
  import {
    getDevicesHistory,
    deleteDevice,
    deleteDevicesAll,
  } from '@/common/requests/data-fetch'
  import {
    MSG_LOGOUT_CURRENT_DEVICE,
    MSG_CONFIRM_LOGOUT_ALL_DEVICE,
  } from '@/common/constant'
  import { isApp } from '@/common/util/common'
  import utils from '@/common/util/utils'
  import { clearStorageForLogout } from '@/common/util/auth.utils'

  const INITIAL_OFFSET = 0
  const INITIAL_LIMIT = 10

  const loginDeviceTotalCount = ref(0)
  const deviceHistoryList = ref([])
  const offset = ref(INITIAL_OFFSET)
  const limit = ref(INITIAL_LIMIT)
  const hasMore = ref(true)
  const isLoading = ref(false)

  const onClickLogoutAll = async () => {
    if (!confirm(MSG_CONFIRM_LOGOUT_ALL_DEVICE)) {
      return
    }
    isLoading.value = true
    const response = await deleteDevicesAll()
    isLoading.value = false
    if (response.status === 200) {
      location.reload()
    }
  }

  const onClickLogout = async ({
    deviceName = '디바이스',
    deviceId,
    currentDevice = false,
  }) => {
    if (!confirm(`'${deviceName}'에서 로그아웃 하시겠습니까?`)) {
      return
    }
    isLoading.value = true
    const response = await deleteDevice({ id: deviceId })
    isLoading.value = false
    if (response.status === 200) {
      if (currentDevice) {
        alert(MSG_LOGOUT_CURRENT_DEVICE)
        // TODO: FLUSH_EVENT 를 해야하면 vue2 컴포넌트로 감싸는 작업 필요
        if (isApp()) {
          location.href = 'captvpooq://logout'
        } else {
          clearStorageForLogout()
          location.href = '/'
        }
      } else {
        location.reload()
      }
    }
  }

  const loadMore = async () => {
    if (!hasMore.value) return
    offset.value += limit.value
    await getDeviceHistoryList()
  }

  const getDeviceHistoryList = async () => {
    const response = await getDevicesHistory({
      offset: offset.value,
      limit: limit.value,
    })
    if (!response || !response?.data || response?.error) {
      alert('디바이스 정보를 가져오는데 실패했습니다.')
      return
    }
    const {
      deviceList: deviceListResponse,
      loginDeviceTotalCount: totalCountResponse,
    } = response.data

    deviceHistoryList.value = [
      ...deviceHistoryList.value,
      ...deviceListResponse,
    ]
    loginDeviceTotalCount.value = totalCountResponse

    if (deviceListResponse.length < limit.value) {
      hasMore.value = false
    }
  }

  onMounted(async () => {
    if (utils.cookies.getCredential() === 'none') {
      location.href = '/'
      return
    }
    await getDeviceHistoryList()
  })
</script>

<style lang="scss" scoped>
  .device-wraper {
    padding: 24px 12px 48px;
  }
  .w-description {
    font-size: 14px;
    text-align: center;
    line-height: 20px;
  }
  .total-count-box {
    display: block;
    margin-top: 24px;
    padding: 16px;
    border-radius: 6px;
    border: 1px solid #2f2f2f;
    font-size: 12px;
    font-style: normal;
    text-align: center;
    line-height: 18px;
  }
  .button-wrapper {
    position: fixed;
    left: 0;
    right: 0;
    bottom: 0;
    padding-bottom: calc(constant(safe-area-inset-bottom));
    padding-bottom: calc(env(safe-area-inset-bottom));
    background-color: #1b1b1b;
    z-index: 10;
    .all-logout-button {
      width: 100%;
      padding: 12px 20px;
      background-color: #0050ff;
      font-size: 16px;
      color: #fff;
      text-align: center;
      line-height: 24px;
    }
  }
</style>
